<template>
  <b-form-group
    label="Şube"
    label-for="branch"
  >
    <validation-provider
      #default="{ errors }"
      name="Şube"
      rules="required"
    >
      <b-form-input
        id="branch"
        v-model="dataItem.branch"
        placeholder="Şube"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'Branch',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['bankAccounts/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
